import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { requestFailback, requestFailover, requestUpdateFailoverConfig } from "./msgs/MsgSender";
import {
    FailoverClusterConfig,
    FailoverClusterStateData,
    FailoverStatusData,
    initFailoverConfig,
    isFailoverNotSet,
    NO_FAILOVER_CONFIG,
} from "userful-chronos-app-common-js/dist/models/failover/failover";

const initialState: {
    failoverConfig: FailoverClusterConfig;
    currentFailoverConfig: FailoverClusterConfig;
    failoverStatus: FailoverStatusData;
    previousStatus: FailoverStatusData;
    clusterStatus: FailoverClusterStateData;
} = {
    failoverConfig: initFailoverConfig(),
    currentFailoverConfig: initFailoverConfig(),
    failoverStatus: null,
    previousStatus: null,
    clusterStatus: null,
};

const refreshFailoverOnConfigDelete = (prevConfig: FailoverClusterConfig, newConfig: FailoverClusterConfig) => {
    if (isFailoverNotSet(newConfig) && !isFailoverNotSet(prevConfig)) {
        console.log("Failover deleted. Refreshing page ...");
        setTimeout(() => window.location.reload(), 1000);
    }
};

const refreshPageIfNecessary = (previousStatus: FailoverStatusData, newStatus: FailoverStatusData) => {
    if (!previousStatus || !newStatus) {
        return;
    }
    if (
        (previousStatus.statusData.status === "passive" && newStatus.statusData.status === "active") ||
        (previousStatus.statusData.status === "active" && newStatus.statusData.status === "passive")
    ) {
        console.log("System became active. Refreshing page ...");
        setTimeout(() => window.location.reload(), 500);
    }
};

export const failoverSlice = createSlice({
    name: "failoverSlice",
    initialState,
    reducers: {
        setFailoverConfig: (state, action: PayloadAction<FailoverClusterConfig>) => {
            // refreshFailoverOnConfigDelete(state.failoverConfig, action.payload);
            state.failoverConfig = { ...action.payload };
            if (!isFailoverNotSet(action.payload)) {
                state.currentFailoverConfig = { ...action.payload };
            } else {
                state.currentFailoverConfig = initFailoverConfig();
            }
        },
        setFailoverStatus: (state, action: PayloadAction<FailoverStatusData>) => {
            state.failoverStatus = { ...action.payload };
            refreshPageIfNecessary(state.previousStatus, action.payload);
            if (action.payload?.statusData.status === "active" || action.payload?.statusData.status === "passive") {
                state.previousStatus = { ...action.payload };
            }
        },
        setClusterStatus: (state, action: PayloadAction<FailoverClusterStateData>) => {
            state.clusterStatus = { ...action.payload };
        },
        setCurrentFailoverConfig: (state, action: PayloadAction<FailoverClusterConfig>) => {
            state.currentFailoverConfig = action.payload ? { ...action.payload } : initFailoverConfig();
        },
        discard: (state) => {
            if (!isFailoverNotSet(state.failoverConfig)) {
                state.currentFailoverConfig = { ...state.failoverConfig };
            } else {
                state.currentFailoverConfig = initFailoverConfig();
            }
        },
        updateFailoverConfig: (state) => {
            if (!state.currentFailoverConfig) {
                return;
            }
            state.failoverConfig = { ...state.currentFailoverConfig };
            requestUpdateFailoverConfig(state.currentFailoverConfig);
        },
        requestDeleteFailover: (state) => {
            state.failoverConfig = { ...NO_FAILOVER_CONFIG };
            state.currentFailoverConfig = initFailoverConfig();
            requestUpdateFailoverConfig(NO_FAILOVER_CONFIG);
        },
        requestFailover: () => {
            requestFailover();
        },
        requestFailback: () => {
            requestFailback();
        },
    },
});

export const failoverSliceActions = failoverSlice.actions;

export default failoverSlice.reducer;
